module.exports = "<button mdTooltip=\"{{ 'USERS_LIST_FAVORITES' | tooltip }} \" mdTooltipPosition='{{aboveTooltip}}' md-mini-fab color='primary'\n  (click)=\"openUserLikesDialog($event)\"> \n    <i>{{item.favoritesCount}}</i>\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/users-favorites-count/users-favorites-count.component.html
// module id = ./src/app/shared/users-favorites-count/users-favorites-count.component.html
// module chunks = main